import React, { memo, useState } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
    Label,
    Form,
    FormGroup,
    Nav,
    NavItem,
    NavLink,
    TabPane,
    TabContent,
    Row,
    CustomInput,
} from 'reactstrap';
import IntlMessages from '../../../../helpers/IntlMessages';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { DynamicForm } from '../../general';
import classNames from 'classnames';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import {
    SetSelectPromotionDiscount,
    SetSelectPromotionGift,
} from '../../../../helpers/SelectPromotion';
import Select from 'react-select';
import {
    CustomOptionComponentDiscount,
    CustomOptionComponentGift,
} from './CustomOptionComponent';
import CustomSelectInput from '../../../../components/common/CustomSelectInput';
const { v4: uuidv4 } = require('uuid');

const ContentComponent = ({
    title,
    isOpen,
    toggle,
    onSubmit,
    values,
    discountRange,
    oneProduct,
    oneTypeProduct,
    quantityProduct,
    quantityTypeProduct,
    customerPoint,
    productGetProduct,
    orderGetProduct,
    customerPointGetProduct,
    customerGroupDiscount,
    firstOrderDiscount,
    onAddItem,
    onAddProduct,
    onRemoveDiscount,
    onRemoveProduct,
    onChange,
    onChangeDynamicForm,
    onChangeItem,
    data_dynamic_form,
}) => {

    const [activeTab, setActiveTab] = useState('1');
    const [selectedOptionDiscount, setSelectedOptionDiscount] = useState(null);
    const [selectedOptionGift, setSelectedOptionGift] = useState(null);

    const onChangeSelectedDiscount = (selected) => {
        setSelectedOptionDiscount(selected.value);
        onChange(selected, 'type');
        onChange({ value: 'DISCOUNT' }, 'promotionType');
    };
    const onChangeSelectedGift = (selected) => {
        setSelectedOptionGift(selected.value);
        onChange(selected, 'type');
        onChange({ value: 'GIFT' }, 'promotionType');
    };

    const toggleTab = (num) => {
        setActiveTab(num);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            wrapClassName='modal-right'
            backdrop={true}
            autoFocus={false}
        >
            <Form onSubmit={(e) => onSubmit(e)}>
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody className='scrool modal-right-add'>
                    <PerfectScrollbar
                        options={{
                            suppressScrollX: true,
                            wheelPropagation: false,
                        }}
                        id='modal-right__body'
                    >
                        <FormGroup className='mt-3 has-float-label'>
                            <Label className='text-muted' for='name'>
                                <IntlMessages id='promotion-name' /><span style={{color: 'red'}}>*</span>
                            </Label>
                            <Input
                                autoFocus={true}
                                type='text'
                                name='name'
                                id='name'
                                value={values.name}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <Row className='d-flex'>
                            <Colxx xxs='6' className='pr-1'>
                                <FormGroup className='has-float-label'>
                                    <Label
                                        className='text-muted'
                                        for='quantity'
                                    >
                                        <IntlMessages id='promotion-quantity' /><span style={{color: 'red'}}>*</span>
                                    </Label>
                                    <Input
                                        type='text'
                                        inputMode='numeric'
                                        pattern='[0-9]*'
                                        name='quantity'
                                        id='quantity'
                                        value={values.quantity}
                                        onChange={onChange}
                                    />
                                </FormGroup>
                            </Colxx>
                            <Colxx xxs='6' className='pl-1'>
                                <FormGroup className='has-float-label'>
                                    <Label className='text-muted' for='code'>
                                        <IntlMessages id='promotion-code' />
                                    </Label>
                                    <Input
                                        disabled
                                        type='text'
                                        name='code'
                                        id='code'
                                        // value={`CTKM-${uuidv4().substring(0, 8).toUpperCase()}`}
                                    />
                                </FormGroup>
                            </Colxx>
                        </Row>
                        <Row className='d-flex'>
                            <Colxx xxs='12'>
                                <FormGroup className='has-float-label'>
                                    <Label
                                        className='text-muted'
                                        for='maxUsagePerCustomer'
                                    >
                                        <IntlMessages id='promotion-max-per-customer' /><span style={{color: 'red'}}>*</span>
                                    </Label>
                                    <Input
                                        type='text'
                                        inputMode='numeric'
                                        pattern='[0-9]*'
                                        name='maxUsagePerCustomer'
                                        id='maxUsagePerCustomer'
                                        value={values.maxUsagePerCustomer}
                                        onChange={onChange}
                                    />
                                </FormGroup>
                            </Colxx>
                        </Row>
                        <Row>
                            <Colxx xxs='6' className='pr-1'>
                                <FormGroup className='has-float-label mb-0'>
                                    <Label className='text-muted' for='date_start'>
                                        <IntlMessages id='promotion-date_start' /><span style={{color: 'red'}}>*</span>
                                    </Label>
                                    <DatePicker
                                        className='mb-3'
                                        name='date-start'
                                        id='date-start'
                                        onChange={(e) =>
                                            onChange(e, 'date_start')
                                        }
                                        selected={values.date_start}
                                        // selected={moment(
                                        //     values.momentFormatSelectDateTimeStart,
                                        //     'DD-MM-YYYY'
                                        // )}
                                        // showTimeSelect
                                        // timeFormat='HH:mm'
                                        // timeIntervals={15}
                                        // dateFormat='YYYY-MM-DD / HH:mm'
                                        // timeCaption='Giờ'
                                    />
                                </FormGroup>
                            </Colxx>
                            <Colxx xxs='6' className='pl-1'>
                                <FormGroup className='has-float-label mb-0'>
                                    <Label className='text-muted' for='date_end'>
                                        <IntlMessages id='promotion-date_end' /><span style={{color: 'red'}}>*</span>
                                    </Label>
                                    <DatePicker
                                        className='mb-3'
                                        name='date_end'
                                        id='date_end'
                                        onChange={(e) =>
                                            onChange(e, 'date_end')
                                        }
                                        selected={values.date_end}
                                        // selected={moment(
                                        //     values.momentFormatSelectDateTimeEnd,
                                        //     'DD-MM-YYYY'
                                        // )}
                                        // showTimeSelect
                                        // timeFormat='HH:mm'
                                        // timeIntervals={15}
                                        // dateFormat='YYYY-MM-DD / HH:mm'
                                        // timeCaption='Giờ'
                                        popperPlacement="bottom-end"
                                    />
                                </FormGroup>
                            </Colxx>
                        </Row>
                        <FormGroup className='has-float-label'>
                            <Label className='text-muted' for='description'>
                                <IntlMessages id='promotion-description' />
                            </Label>
                            <Input
                                type='text'
                                name='description'
                                id='description'
                                value={values.description}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <div className="custom-control custom-checkbox align-self-center">
                            <CustomInput
                                className="itemCheck mb-1"
                                type="checkbox"
                                id={'isAutoUse'}
                                // name={'isAutoUse'}
                                checked={values.isAutoUse}
                                onChange={(e) =>
                                    onChange(
                                        { value: e.target.checked },
                                        'isAutoUse'
                                    )
                                }
                                label="Tự động áp dụng"
                            />
                        </div>
                        <div className="custom-control custom-checkbox align-self-center">
                            <CustomInput
                                className="itemCheck mb-3"
                                type="checkbox"
                                id={'isStackable'}
                                checked={values.isStackable}
                                onChange={(e) =>
                                    onChange(
                                        { value: e.target.checked },
                                        'isStackable'
                                    )
                                }
                                label="Có thể kết hợp với khuyến mại khác"
                            />
                        </div>

                        {/* Khung giờ / ngày áp dụng */}
                        <Label className="text-muted mt-3 mb-2">Khung giờ & ngày áp dụng (tùy chọn)</Label>
                        <div className="d-flex mb-2" style={{ gap: '10px' }}>
                            <div style={{ flex: 1 }}>
                                <Label className="text-small">Từ giờ</Label>
                                <Input
                                    type="time"
                                    value={values.activeTimeStart || ''}
                                    onChange={(e) => onChange({ value: e.target.value }, 'activeTimeStart')}
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <Label className="text-small">Đến giờ</Label>
                                <Input
                                    type="time"
                                    value={values.activeTimeEnd || ''}
                                    onChange={(e) => onChange({ value: e.target.value }, 'activeTimeEnd')}
                                />
                            </div>
                        </div>
                        <div className="d-flex flex-wrap mb-3" style={{ gap: '6px' }}>
                            {['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'].map((day, idx) => {
                                const activeDays = values.activeDays || [];
                                const isActive = activeDays.includes(idx);
                                return (
                                    <span
                                        key={idx}
                                        className={`badge cursor-pointer ${isActive ? 'badge-primary' : 'badge-outline-secondary'}`}
                                        style={{ padding: '6px 10px', fontSize: '12px', borderRadius: '15px' }}
                                        onClick={() => {
                                            const newDays = isActive
                                                ? activeDays.filter(d => d !== idx)
                                                : [...activeDays, idx];
                                            onChange({ value: newDays.length > 0 ? newDays : [] }, 'activeDays');
                                        }}
                                    >
                                        {day}
                                    </span>
                                );
                            })}
                        </div>

                        <DynamicForm
                            values={values.dynamic_form}
                            data={data_dynamic_form}
                            onChange={onChangeDynamicForm}
                        />
                        <Nav
                            tabs
                            className='d-flex justify-content-around separator-tabs ml-0 mb-4 cursor-pointer'
                        >
                            <NavItem className='w-50 text-center'>
                                <NavLink
                                    className={classNames({
                                        active: activeTab === '1',
                                        'nav-link': true,
                                        'mr-0': true,
                                    })}
                                    onClick={() => toggleTab('1')}
                                    location={{}}
                                    to='#'
                                >
                                    Giảm giá
                                </NavLink>
                            </NavItem>
                            <NavItem className='w-50 text-center'>
                                <NavLink
                                    className={classNames({
                                        active: activeTab === '2',
                                        'nav-link': true,
                                    })}
                                    onClick={() => toggleTab('2')}
                                    location={{}}
                                    to='#'
                                >
                                    Quà tặng
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId='1'>
                                <FormGroup>
                                    <Select
                                        components={{
                                            Input: CustomSelectInput,
                                        }}
                                        className='react-select'
                                        classNamePrefix='react-select'
                                        placeholder={
                                            <IntlMessages id='select-one-time-discount' />
                                        }
                                        options={SetSelectPromotionDiscount()}
                                        onChange={(e) => {
                                            onChangeSelectedDiscount(e);
                                        }}
                                    />
                                </FormGroup>
                                {selectedOptionDiscount && (
                                    <CustomOptionComponentDiscount
                                        selectedOption={selectedOptionDiscount}
                                        values={values}
                                        discountRange={discountRange}
                                        oneProduct={oneProduct}
                                        oneTypeProduct={oneTypeProduct}
                                        quantityProduct={quantityProduct}
                                        quantityTypeProduct={
                                            quantityTypeProduct
                                        }
                                        customerPoint={customerPoint}
                                        customerGroupDiscount={customerGroupDiscount}
                                        firstOrderDiscount={firstOrderDiscount}
                                        onAddItem={onAddItem}
                                        onAddProduct={onAddProduct}
                                        onRemoveDiscount={onRemoveDiscount}
                                        onRemoveProduct={onRemoveProduct}
                                        onChange={onChange}
                                        onChangeItem={onChangeItem}
                                    />
                                )}
                            </TabPane>
                            <TabPane tabId='2'>
                                <FormGroup>
                                    <Select
                                        components={{
                                            Input: CustomSelectInput,
                                        }}
                                        className='react-select'
                                        classNamePrefix='react-select'
                                        name='type'
                                        placeholder={
                                            <IntlMessages id='select-one-time-gift' />
                                        }
                                        options={SetSelectPromotionGift()}
                                        onChange={(e) => {
                                            onChangeSelectedGift(e);
                                        }}
                                    />
                                </FormGroup>
                                {selectedOptionGift && (
                                    <CustomOptionComponentGift
                                        selectedOption={selectedOptionGift}
                                        onChange={onChange}
                                        productGetProduct={productGetProduct}
                                        orderGetProduct={orderGetProduct}
                                        customerPointGetProduct={
                                            customerPointGetProduct
                                        }
                                        onAddItem={onAddItem}
                                        onAddProduct={onAddProduct}
                                        onRemoveDiscount={onRemoveDiscount}
                                        onRemoveProduct={onRemoveProduct}
                                        onChangeItem={onChangeItem}
                                    />
                                )}
                            </TabPane>
                        </TabContent>
                    </PerfectScrollbar>
                </ModalBody>
                <ModalFooter>
                    <Button color='primary'>
                        <IntlMessages id='general.btn-add' />
                    </Button>{' '}
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default memo(ContentComponent);
